import React, { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function LogOut() {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();

  const handleLogOut = () => {
    Swal.fire({
      title: "Log Out",
      text: "Are you sure you want to log out?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, log out",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoggingOut(true);

        // Clear all localStorage data
        localStorage.clear();

        // Show success message
        Swal.fire({
          title: "Logged Out!",
          text: "You have been successfully logged out.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          // Redirect to login page using Navigate
          navigate("/login");
        });
      }
    });
  };

  return (
    <button
      className="btn deleteButton"
      onClick={handleLogOut}
      disabled={isLoggingOut}
      style={{
        backgroundColor: isLoggingOut ? "#ccc" : undefined,
        cursor: isLoggingOut ? "not-allowed" : "pointer",
      }}
    >
      <i
        className={`fa ${isLoggingOut ? "fa-spinner fa-spin" : "fa-sign-out"}`}
      />
      {isLoggingOut ? "Logging out..." : "Log Out"}
    </button>
  );
}
